import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowLeft, Bell } from "@phosphor-icons/react";
import { MarketingNav, MarketingFooter, BTN_GREEN } from "./_shared";

/**
 * Coming soon placeholder rendered in lieu of any disabled marketing page.
 * Keeps SEO + UX polished — no broken 404s.
 */
export default function ComingSoon({ pageLabel }) {
  React.useEffect(() => {
    document.title = `${pageLabel || "Coming soon"} · Rescigo Health`;
  }, [pageLabel]);
  return (
    <div className="min-h-screen bg-white" data-testid="page-coming-soon">
      <MarketingNav/>
      <section className="pt-40 pb-32">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-[10px] uppercase tracking-[0.22em] font-semibold mb-7">
            <Clock size={11} weight="fill"/> Coming soon
          </div>
          <h1 className="font-heading text-5xl md:text-6xl text-slate-900 leading-[1.05]">
            {pageLabel ? <>{pageLabel} is on its way.</> : <>This page is on its way.</>}
          </h1>
          <p className="text-lg text-slate-600 mt-6 max-w-xl mx-auto leading-relaxed">
            We're putting the finishing touches on this section. Drop us a line and we'll
            ping you the moment it goes live.
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            <Link to="/contact" data-testid="cs-contact" className={BTN_GREEN}>
              <Bell size={13} weight="fill"/> Notify me when it's live
            </Link>
            <Link to="/" className="inline-flex items-center gap-2 h-12 px-5 rounded-full border border-slate-300 text-slate-800 hover:border-slate-400 text-sm font-medium">
              <ArrowLeft size={13}/> Back to home
            </Link>
          </div>
        </div>
      </section>
      <MarketingFooter/>
    </div>
  );
}
